<template>
  <div class="app-main__inner">
    <TituloComponent icono-titulo="fas fa-pencil-alt" :texto-titulo="'Legajo Numero '+ legajo.numero"></TituloComponent>
    <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
      <div class="row">
        <div class="col-lg-12 mb-4">
          <div class="main-card mb-3 card">
              <div class="card-body divPersona">
                  <h5 class="border-bottom"><i class="fas fa-user btn-icon-wrapper btn-icon-sm mb-2"></i> Persona</h5>
                  <div class="widget-content">
                      <div class="widget-content-wrapper row">
                          <div class="widget-content-left col-12">
                              <h5 class="widget-heading text-alternate">{{persona.nombre}} {{persona.apellido}}</h5>
                              <div class="widget-subheading opacity-10 row">
                                  <span class="col-sm-auto col-12 text-alternate">
                                  N° Doc/CUIL:
                                  <b>{{persona.cuil}}</b>
                                  </span>
                                  <span class="col-sm-auto col-12 text-alternate">
                                  N° Afiliado
                                  <b>{{persona.numero_afiliado}}</b>
                                  </span>
                                  <span class="col-sm-auto col-12 text-alternate">
                                  Domicilio:
                                  <b>{{persona.domicilio}}</b>
                                  </span>
                                  <span class="col-sm-auto col-12 text-alternate">
                                  Localidad:
                                  <b>{{persona.provincia}} - {{persona.localidad}}</b>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="main-card mb-3 card">
            <div class="card-body">
                <h5 class="border-bottom"><i class="fas fa-briefcase btn-icon-wrapper btn-icon-sm mb-2"></i> Datos Laborales</h5>
                <div class="row pt-3">
                    <div class="col-lg-4">
                        <h5 class="widget-heading text-primary">Categoria</h5>
                        <p>{{legajo.categoria.descripcion}}</p>
                     </div>
                    <div class="col-lg-4">
                        <h5 class="text-primary">Seccion</h5>
                        <p>{{legajo.seccion.descripcion}}</p>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-primary">Cargo</h5>
                        <p>{{legajo.cargo.descripcion}}</p>
                    </div>                                        
                    <div class="col-lg-4">
                        <h5 class="text-primary">Clase</h5>
                        <p>{{legajo.clase}}</p>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-primary">Fecha de ingreso</h5>
                        <p>{{legajo.fecha_ingreso}}</p>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-primary">Fecha de ingreso reconocida</h5>
                        <p>{{legajo.fecha_ingreso_reconocida}}</p>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-primary">Fecha de Egreso</h5>
                        <p>{{legajo.fecha_egreso}}</p>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-primary">Situacion de revista</h5>
                        <p>{{legajo.situacion_revista.descripcion}}</p>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-primary">Lugar de trabajo</h5>
                        <p>{{legajo.lugar_trabajo}}</p>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-primary">Lugar de pago</h5>
                        <p>{{legajo.lugar_pago}}</p>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-primary">Discapacidad</h5>
                        <p v-if="legajo.discapacidad">Posee Discapacidad</p>
                        <p v-else>No posee discapacidad</p>
                     </div>
                     <div class="col-lg-4">
                        <h5 class="text-primary">Personal Temporario</h5>
                        <p v-if="legajo.personal_temporario">Es personal temporario</p>
                        <p v-else>No es personal temporario</p>
                     </div>
                </div>
            </div>
          </div>
          <div class="main-card mb-3 card">
            <div class="card-body">
                <h5 class="border-bottom"><i class="metismenu-icon fas fa-file-alt btn-icon-wrapper btn-icon-sm mb-2"></i> Datos de Liquidacion</h5>
                <div class="row pt-3">
                    <div class="col-lg-3">
                        <h5 class="text-success">Forma de pago</h5>
                        <p>{{legajo.forma_pago}}</p>
                    </div>
                    <div class="col-lg-3">
                        <h5 class="text-success">Sindicato</h5>
                        <p>{{legajo.sindicato.descripcion}}</p>
                    </div>
                    <div class="col-lg-3">
                        <h5 class="text-success">Obra Social</h5>
                        <p>{{legajo.obra_social.descripcion}}</p>
                    </div>  
                    <div class="col-lg-3">
                        <h5 class="text-success">Regimen Jubilatorio</h5>
                        <p>{{legajo.regimen_jubilatorio.descripcion}}</p>
                     </div>
                    <div class="col-lg-3">
                        <h5 class="text-success">Modalidad contratacion</h5>
                        <p>{{legajo.modalidad_contratacion.descripcion}}</p>
                    </div>
                    <div class="col-lg-3">
                        <h5 class="text-success">Banco</h5>
                        <p>{{legajo.banco}}</p>
                    </div>
                </div>
            </div>
          </div>
          <div class="main-card mb-3 card">
            <div class="card-body">
              <h5 class="border-bottom"><i class="metismenu-icon fas fa fa-money-check-alt btn-icon-wrapper btn-icon-sm mb-2"></i> Recibos</h5>
              <div class="row pt-3">
                <div class="col-lg-12">
                  <div class="mb-3 col-12">
                    <div class="row">
                      <ul class="list-group list-group-flush mb-3" v-if="searching">
                      <li class="list-group-item">
                        <div class="skeleton">
                          <div class="skeleton-author"></div>
                          <div class="skeleton-content"></div>
                          <div class="skeleton-content"></div>
                        </div>
                      </li>
                      <li class="list-group-item">
                        <div class="skeleton">
                          <div class="skeleton-author"></div>
                          <div class="skeleton-content"></div>
                          <div class="skeleton-content"></div>
                        </div>
                      </li>
                    </ul>
                    <ul class="list-group list-group-flush mb-3" v-else-if="legajo.recibos.length == 0">
                      <li class="list-group-item">
                        <h5 class="text-center">No se encontraron resultados</h5>
                      </li>
                    </ul>
                    <ul class="list-group list-group-flush mb-3 col-12" v-else>
                        <li class="list-group-item hoverable" v-for="(recibo, i) in legajo.recibos" :key="i" @click="verRecibo(recibo)">
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper row">
                              <div class="widget-content-left col-12">
                                <h5 class="widget-heading">
                                  <span class="text-primary">
                                      <span>{{recibo.per_dep}} - {{recibo.mensual_jornal}}</span>
                                  </span>
                                </h5>
                                <div class="widget-subheading opacity-10 row">
                                  <span class="col-sm-auto col-12 row">
                                    <span class="text-left col-sm-auto col-12">
                                      Seccion:
                                      <b class="text-alternate">{{recibo.seccion}}</b>
                                    </span>
                                    <span class="ml-lg-3 text-left col-sm-auto col-12">
                                      Neto:
                                      <b class="text-alternate"> $ {{recibo.neto}}</b>
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                    </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>          
          <div class="col-lg-12">
            <router-link :to="{name:'EditarLegajo', params:{id:legajo.id}}">
            <button class="mt-1 btn btn-success float-right">Editar</button>
           
            </router-link>
            <button @click="eliminarLegajo()" class="mt-1 btn btn-danger float-right mr-4">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";
import axios from "axios";
import Swal from "sweetalert2";
import Legajo from "@/models/legajo";
import Persona from '@/models/persona';
import '@/assets/css/chekbox.css';
export default {
  name: "VerLegajo",
  components: {
    TituloComponent,
  },
  data() {
    return {
        legajo: new Legajo(null, //id
                           null, //nbumero
                           null,//institucion
                           null, //persona
                           null, //categoria
                           null, //seccion
                           null,//cargo
                           'Mensual', //clase
                           false,//personal temporario
                           false, //discapacidad
                           null, //situaciond e revista
                           null, //fecha ingreso
                           null,  //fecha ingreso reconocida
                           null, //sindicato
                           null, //regimen jubilatorio
                           null,  //plan medico
                           null, //obra social
                           null,   //modalidad contratacion
                           null, //forma pago
                           'Banco La Pampa', //banco
                           null,//lugar de trabajo
                           null),//lugar de pago
        persona: new Persona(null, null, null, null, null, null, null, null, null, null, null, null),
        loading: false,
        enviado: false,
        institucion: JSON.parse(localStorage.getItem('institucion')),
        searching:false,
    };
  },
  mounted() {
    console.log("hizo el mounted")
    this.legajo.id = this.$route.params.id;
    this.getLegajo();
  },
  methods: {
    getLegajo() {
      this.loading = true;
      axios
        .get("legajos/" + this.legajo.id)
        .then((res) => {
          console.log(res.data);
          if (res.data.success) {
            console.log(res.data)
            this.legajo = res.data.legajo;
            this.persona = res.data.persona;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado Legajos.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    eliminarLegajo() {
      console.log(this.legajo)
        Swal.fire({
            title: "¿Estás seguro?",
            text: `¿Deseas eliminar el legajo N° ${this.legajo.numero} de manera permanente?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
            this.loading = true;
            axios
                .delete("legajos/" + this.legajo.id)
                .then(res => {
                Swal.fire(
                    "Eliminado",
                    `${res.data.legajo.numero} se ha eliminado con éxito.`,
                    "success"
                );
                console.log(this.$refs);
                this.$router.push({ name: "ListarLegajos" });
                })
                .catch(err => console.log(err))
                .finally(() => (this.loading = false));
            }
        });
      },
      verRecibo(recibo){
        this.loading = true;
        axios
          .get("/recibos/imprimir/" + recibo.id, {
            responseType: "arraybuffer",
          })
          .then((res) => {
            let blob = new Blob([res.data], { type: "application/pdf" }),
              url = window.URL.createObjectURL(blob);
            window.open(url);
            this.loading = false;
          })
          .catch((err) => console.log(err))
          .finally(() => (this.loading = false));
      },
  }
};
</script>
